/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Highlight_Previous_EventInputs */

const en_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add previous Event to Selected Events`)
};

const fr_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter l'evenement precedent aux evenements selectionnes`)
};

const de_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis zu den ausgewählten Ereignissen hinzufügen`)
};

const it_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi l'evento precedente agli eventi selezionati`)
};

const ru_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить предыдущее событие в список выбранных событий`)
};

const es_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar evento anterior a Eventos seleccionados`)
};

const zh_cn2_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将上一个事件添加到选定事件中`)
};

const ja_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントに前のイベントを追加する`)
};

const hi_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली घटना को चयनित घटनाओं में जोड़ें`)
};

const pt_pt2_shortcut_keys_desc_highlight_previous_event = /** @type {(inputs: Shortcut_Keys_Desc_Highlight_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar evento anterior aos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Add previous Event to Selected Events" |
*
* @param {Shortcut_Keys_Desc_Highlight_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_highlight_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Highlight_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Highlight_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_highlight_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_highlight_previous_event(inputs)
	return en_shortcut_keys_desc_highlight_previous_event(inputs)
});